import apiCities from '../apis/Cities'

export async function selectCountries() {
  try {
    const response = await apiCities.getCountries();
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function selectStates() {
  try {
    const response = await apiCities.getStates();
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function selectCities(stateId) {
  try {
    const response = await apiCities.getCities(stateId);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}